import { Schema } from '@core/data/dto/schema';
import { DeliveryOrderDropoffVerification } from './delivery-order-dropoff-verification';

export const DeliveryOrderDropoffSchema = {
    name: Schema.String,
    phone_number: Schema.String,
    address: Schema.String,
    notes: Schema.String,
    location: Schema.Auto,
    detailed_address: Schema.Auto,
    verification: DeliveryOrderDropoffVerification
};
